// Utils
import { pixelsToGridPoints } from '../../utils/grid/gridUtils';
import { getBoundingRect } from '../../../common/maths/geometry/rect';
import { isLine } from '../../../common/elements/utils/elementTypeUtils';
import { isIconViewLike } from '../../../common/elements/utils/elementDisplayUtils';
import { getElementId } from '../../../common/elements/utils/elementPropertyUtils';

// Constants
import { DEFAULT_ICON_VIEW_WIDTH } from '../../../common/elements/elementDisplayModeConstants';
import { BOARD_ALIGNMENT_OFFSET } from '../../workspace/toolbar/selectionTools/arrangementTools/alignmentTools/alignmentConstants';
import { LINE_HIT_AREA } from '../../element/line/lineUiConstants';

export const getMeasurementWithBoardOffset = (measurements, gridSize) => (el) => {
    const elementId = getElementId(el);
    const measurement = measurements.get(elementId).toJS();
    measurement.id = elementId;

    if (isIconViewLike(el)) {
        // Not including the text in the board measurements
        const width = (DEFAULT_ICON_VIEW_WIDTH - 2) * gridSize;
        const height = (DEFAULT_ICON_VIEW_WIDTH - 2) * gridSize;

        const left = measurement.left + BOARD_ALIGNMENT_OFFSET * gridSize;
        const top = measurement.top + BOARD_ALIGNMENT_OFFSET * gridSize;

        return {
            ...measurement,
            x: left,
            y: top,
            left,
            right: left + width,
            top,
            bottom: top + height,
            width,
            height,
        };
    }

    if (isLine(el)) {
        // Line offsets are not dependent on grid size
        return {
            ...measurement,
            bottom: measurement.bottom - LINE_HIT_AREA,
            right: measurement.right - LINE_HIT_AREA,
            width: measurement.width - LINE_HIT_AREA,
            height: measurement.height - LINE_HIT_AREA,
        };
    }

    return {
        ...measurement,
        // Need to add border width
        width: measurement.width + 2,
        height: measurement.height + 2,
    };
};

export const getBoundingRectInGridUnits = ({ elements, measurements, gridSize, rounded = true }) => {
    const measurementsArray = elements.map(getMeasurementWithBoardOffset(measurements, gridSize));
    const boundingRect = getBoundingRect(measurementsArray);

    return {
        left: rounded ? pixelsToGridPoints(boundingRect.left, gridSize) : boundingRect.left / gridSize,
        right: rounded ? pixelsToGridPoints(boundingRect.right, gridSize) : boundingRect.right / gridSize,
        top: rounded ? pixelsToGridPoints(boundingRect.top, gridSize) : boundingRect.top / gridSize,
        bottom: rounded ? pixelsToGridPoints(boundingRect.bottom, gridSize) : boundingRect.bottom / gridSize,
    };
};
